var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "next (6) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.68923 11.0371L13.3981 18.7246C13.6506 18.9763 14.0595 18.9759 14.3117 18.7233C14.5636 18.4707 14.563 18.0616 14.3104 17.8097L7.06042 10.5797L14.3107 3.3498C14.5632 3.09785 14.5639 2.68896 14.312 2.43636C14.1856 2.30973 14.02 2.24642 13.8544 2.24642C13.6892 2.24642 13.5243 2.30931 13.3981 2.43506L5.68923 10.1224C5.56759 10.2434 5.49932 10.4081 5.49932 10.5797C5.49932 10.7513 5.56778 10.9159 5.68923 11.0371Z",
    fill: "#046C9C",
    stroke: "#046C9C",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.6d95bd3fba1347ee8ac38dbf8c2149db.svg";
export { ForwardRef as ReactComponent };